import durationService from "../../../../common/utils/duration/duration.service";
import orderTranslationsHelper from "../../../../languages/order-translations.helper";
import OrderDetailsRouteWaypoint from "../common/types/order-details-route-waypoint";

const getDateLabel = (date: Date | null): string => {
  if (!date) {
    return `----`;
  }

  return date.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  });
};

const getDateTitle = (date: Date | null): string => {
  if (!date) {
    return ``;
  }

  return `${date.toLocaleDateString()} ${date.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};

const getOrderedDateLabel = (orderedDate: Date | null): string => {
  return getDateLabel(orderedDate);
};

const getOrderedDateTitle = (orderedDate: Date | null): string => {
  return getDateTitle(orderedDate);
};

const getEstimatedDateLabel = (estimatedDate: Date | null): string => {
  return getDateLabel(estimatedDate);
};

const getEstimatedDateTitle = (estimatedDate: Date | null): string => {
  return getDateTitle(estimatedDate);
};

const getCompletionDateLabel = (completionDate: Date | null): string => {
  return getDateLabel(completionDate);
};

const getCompletionDateTitle = (completionDate: Date | null): string => {
  return getDateTitle(completionDate);
};

const getHaltingTimeLabel = (haltingTime: number): string => {
  const translations = orderTranslationsHelper.getDetailsTranslations();

  const formattedHaltingTime = durationService.format(haltingTime);

  return translations.routes.haltingDateTemplateText.replace(
    "#{duration}",
    formattedHaltingTime,
  );
};

const getDistanceLabel = (distance: number | null): string => {
  if (distance === null) {
    return `----`;
  }

  const distanceAsKm = distance / 1000;

  return `${distanceAsKm.toFixed(1)} KM`;
};

const generateWaypointDotClassname = (
  waypoint: OrderDetailsRouteWaypoint,
  orderUuid: string,
) => {
  return `dot-order-${orderUuid}-coordinates-${waypoint.place.latitude};${waypoint.place.longitude}-stageNo-${waypoint.stageNo}`;
};

const orderDetailsRouteHelper = {
  getOrderedDateLabel,
  getOrderedDateTitle,
  getEstimatedDateLabel,
  getEstimatedDateTitle,
  getCompletionDateLabel,
  getCompletionDateTitle,
  getHaltingTimeLabel,
  getDistanceLabel,
  generateWaypointDotClassname,
};

export default orderDetailsRouteHelper;
